'use client';

import React, { FC } from 'react';

import { LocationGroupTitle } from './GroupTitle.styled';

interface GroupTitleProperties {
  title: string | undefined;
  dataTestId?: string;
}

export const GroupTitle: FC<GroupTitleProperties> = ({
  title,
  dataTestId = 'location-search-group-title',
}) => {
  if (!title) {
    return <></>;
  }

  return (
    <LocationGroupTitle data-testid={dataTestId}>{title}</LocationGroupTitle>
  );
};
